import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
export const ProtectedRoute = ({ children }) => {
    const { isAuth, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return _jsx("div", { children: "Loading..." });
    }
    if (!isAuth) {
        return _jsx(Navigate, { to: "/login", state: { from: location }, replace: true });
    }
    return children;
};
